export { PaymentInfoDisplay } from './paymentInfoDisplay';
export type {
  BoletoPaymentInfo, CatalogPaymentInfo, CreditCardPaymentInfo, DeliveryLinkPaymentInfo, DigitalWalletPaymentInfo, PaymentInfo,
  PaymentInfoDisplayProps, PixPaymentInfo, SubscriptionPaymentInfo, UniqueLinkPaymentInfo
} from './types';

